import { render, staticRenderFns } from "./MyRegistraions.vue?vue&type=template&id=31c8fcc0"
import script from "./MyRegistraions.vue?vue&type=script&lang=js"
export * from "./MyRegistraions.vue?vue&type=script&lang=js"
import style0 from "./MyRegistraions.vue?vue&type=style&index=0&id=31c8fcc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports